(() => {
  if (window.__guttifulFreeGiftsInit) return;
  window.__guttifulFreeGiftsInit = true;

  // Variant IDs for the 3-bottle and 5-bottle tiers — buying either one
  // qualifies for the free e-book bonus advertised on the product page.
  const QUALIFYING_VARIANT_IDS = ['58088982315390', '58088982053246'];
  const EBOOK_VARIANT_ID = '58340075045246';

  function fetchConfig(contentType = 'application/json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': contentType, Accept: 'application/json' },
    };
  }

  // Re-renders the same sections Dawn's own cart-drawer quantity updates
  // do, mirroring the pattern already established in shipping-protection.js.
  function renderSections(sections) {
    const sectionIds = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];

    sectionIds.forEach(({ id, section, selector }) => {
      const html = sections[section];
      if (!html) return;
      const container = document.getElementById(id);
      if (!container) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector(selector);
      const target = container.matches(selector) ? container : container.querySelector(selector);
      if (newContent && target) {
        target.innerHTML = newContent.innerHTML;
      }
    });
  }

  let syncInFlight = false;

  function sync() {
    if (syncInFlight) return;
    syncInFlight = true;

    fetch(window.routes.cart_url + '.js')
      .then((response) => response.json())
      .then((cart) => {
        const hasQualifyingTier = cart.items.some((item) =>
          QUALIFYING_VARIANT_IDS.includes(String(item.variant_id))
        );
        const ebookLineIndex = cart.items.findIndex(
          (item) => String(item.variant_id) === EBOOK_VARIANT_ID
        );

        if (hasQualifyingTier && ebookLineIndex === -1) {
          return fetch(window.routes.cart_add_url + '.js', {
            ...fetchConfig(),
            body: JSON.stringify({
              items: [{ id: EBOOK_VARIANT_ID, quantity: 1, properties: { _bonus_item: 'Free with bundle' } }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.sections) renderSections(state.sections);
            });
        }

        if (!hasQualifyingTier && ebookLineIndex !== -1) {
          return fetch(window.routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              line: ebookLineIndex + 1,
              quantity: 0,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.sections) renderSections(state.sections);
            });
        }

        return null;
      })
      .finally(() => {
        syncInFlight = false;
      });
  }

  // Debounced: the cart drawer re-renders itself as a side effect of the
  // sync() calls above, which would otherwise retrigger this observer in a
  // tight loop on every single mutation (quantity steppers, etc).
  let debounceTimer = null;
  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 400);
  }

  sync();
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(debouncedSync).observe(cartDrawer, { childList: true, subtree: true });
  }
})();
